<script lang="ts" setup>
  import type { UserInfoBackoffice } from '@solfacil/girassol/dist/types/components/headers/header-backoffice/user-info/types';
  import { useKeycloak } from '@solfacil/plasma-utils';

  import { useApplication } from '@/composables/application';
  import { useUser } from '@/composables/user';
  import { APP_NAME } from '@/constants';

  const { applications, menus } = useApplication(resolveComponent('nuxt-link'));
  const route = useRoute();

  const user = ref<UserInfoBackoffice['user']>();
  const openSidebar = ref<boolean>(true);

  onBeforeMount(() => {
    const authUser = useUser().get();
    user.value = {
      completeName: authUser!.fullName!,
      profile: authUser!.profile!,
    };
  });
</script>

<template>
  <SolBackofficeTemplate>
    <template #sidebar>
      <SolSidebarBackoffice
        :key="route.path"
        :applications="applications"
        :menus="menus"
        :open="openSidebar" />
    </template>

    <template #header>
      <SolHeaderBackoffice
        :title="APP_NAME"
        @toggle-menu="e => (openSidebar = e)">
        <template #actions>
          <SolApplicationsBackoffice :applications="applications" />
          <SolUserInfoBackoffice
            :user="user"
            @logout="() => useKeycloak().logout()" />
        </template>
      </SolHeaderBackoffice>
    </template>

    <template #page>
      <NuxtPage />
    </template>
  </SolBackofficeTemplate>
</template>
